import { UsersManagement } from '@workos-inc/widgets';
import { useOutletContext } from 'react-router-dom';

import { makeAuthTokenGetter } from '../lib/widget-token.ts';

import type { SettingsOutletContext } from './Settings.tsx';

/**
 * /settings/team — WorkOS UsersManagement widget.
 *
 * Server-side: requires the `widgets:users-table:manage` scope, which
 * our /v1/auth/tokens/widget endpoint grants for `widget=user-management`.
 *
 * Member-vs-owner: the widget renders different affordances based on
 * the caller's WorkOS role. Our SPA-side gate is informational only —
 * we render the widget regardless and let WorkOS show the right UI.
 */
export function SettingsTeam() {
  const { orgSlug, role } = useOutletContext<SettingsOutletContext>();

  return (
    <div>
      <h2>Team</h2>
      {role !== 'admin' ? (
        <p className="muted" style={{ marginBottom: '1rem' }}>
          You&apos;re a member of this org. Invites and role changes are owner-only.
        </p>
      ) : null}
      <UsersManagement authToken={makeAuthTokenGetter(orgSlug, 'user-management')} />
    </div>
  );
}
